import ServicePage from "../ServicePage";
import { servicesData } from "@/mocks/services";

export default function PackLocationPage() {
  return <ServicePage data={servicesData["pack-location"]} />;
}
